// extracted by mini-css-extract-plugin
export var inline = "_vm-0";